import { jsx as o } from "react/jsx-runtime";
import { InputLabelWrapper as n } from "../input-label-wrapper/InputLabelWrapper.component.js";
import { s as t } from "../../LabeledTextInput.component.module-DkvNCwxG.js";
import { c } from "../../index-C3-ZVs5E.js";
import { InputThemeEnum as l } from "../input/types.js";
import { NumberInput as u } from "../input/NumberInput.component.js";
const N = ({
  id: r,
  labelText: m,
  inputTheme: e,
  containerClassName: s,
  ...a
}) => {
  const p = r ? `${r}-error` : void 0;
  return /* @__PURE__ */ o(
    n,
    {
      labelText: m,
      id: r,
      containerClassName: s,
      className: c(t.label, {
        [t.secondary]: e === l.secondary
      }),
      children: /* @__PURE__ */ o(
        u,
        {
          ...a,
          inputTheme: e,
          id: r,
          "data-testid": `${r}Input`,
          "aria-describedby": p
        }
      )
    }
  );
};
export {
  N as LabeledNumberInput
};
